import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Tag as TagIcon, Trash2 } from "lucide-react";
import { toast } from "sonner";
import TagEditor from "@/components/customers/TagEditor";

/** mode: null | 'add' | 'remove' */
export const BulkTagDialog = ({ mode, onClose, selectedIds, onDone }) => {
  const [bulkTagInput, setBulkTagInput] = useState([]);

  const runBulkTag = async () => {
    if (!bulkTagInput.length) return toast.error("Pick at least one tag");
    try {
      const body = { ids: selectedIds };
      if (mode === "add") body.add = bulkTagInput;
      else body.remove = bulkTagInput;
      const r = await api.post("/customers/bulk-tag", body);
      toast.success(`${r.data.modified} customer(s) updated`);
      setBulkTagInput([]);
      onClose();
      onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <Dialog open={!!mode} onOpenChange={(v) => { if (!v) { setBulkTagInput([]); onClose(); } }}>
      <DialogContent data-testid="bulk-tag-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">
            {mode === "add" ? "Add tags to selection" : "Remove tags from selection"}
          </DialogTitle>
          <DialogDescription className="text-xs text-slate-500">
            {selectedIds.length} customer{selectedIds.length === 1 ? "" : "s"} will be {mode === "add" ? "tagged" : "untagged"}.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label className="text-xs">Tags</Label>
          <TagEditor value={bulkTagInput} onChange={setBulkTagInput} placeholder="Type and press Enter…" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={runBulkTag}
                  className={mode === "remove" ? "bg-rose-600 hover:bg-rose-700" : "bg-indigo-600 hover:bg-indigo-700"}
                  data-testid="bulk-tag-confirm-btn">
            {mode === "add" ? <><TagIcon className="w-3.5 h-3.5 mr-1.5" /> Add</> : <><Trash2 className="w-3.5 h-3.5 mr-1.5" /> Remove</>}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
